module.exports = __webpack_public_path__ + "media/images/ih-logo-bde4d22d43d2f7254fa102b6ab6d7ef8.svg";